<forge-checkbox #input [formControl]="formControl" [id]="controlName">
    <label [for]="controlName" class="forge-typography--body1">
        <span class="label-truncate">{{label}}</span>
    </label>
    <forge-tooltip *ngIf="showTooltip">{{tooltip}}</forge-tooltip>
</forge-checkbox>
